<div class="modal-content">
  <gtw-confirmation-modal
    [config]="confirmConfig"
    [visible]="false"
    (confirmed)="onConfirm()"
    (cancelled)="onCancel()"
    (closed)="onCancel()">
  </gtw-confirmation-modal>
</div>
